import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import UiGroup from "./UiGroup";

/**
 * 征免性质表单
 * @description 自动生成的代码,请勿修改
 */
export default class DtoFormExemptionNature extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 名称
     */
    Abbr?: string;
    /**
     * 海关代码
     */
    Code?: string;
    /**
     * 全名
     */
    Name?: string;
}

/**
 * 征免性质表单-表单校验
 */
export const DtoFormExemptionNatureRules = {
    Abbr: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "blur",
        },
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
    Code: [
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
    Name: [
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
}

/**
 * 征免性质表单-设置项
 */
export const DtoFormExemptionNatureMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "Abbr",
    Label: "名称",
    Customize: true,
  },
  {
    Prop: "Code",
    Label: "海关代码",
    Customize: true,
  },
  {
    Prop: "Name",
    Label: "全名",
    Customize: true,
  },
]
